import { ICustomer } from '../../interfaces'

export const addCustomer = (customer: ICustomer) => customer

export const clearSelectedCustomer = () => null
